export type { HoverCardProps } from '@mantine/core';
export { HoverCard as default } from '@mantine/core';

export const HOVER_CARD_STYLES = {
	dropdown: {
		backgroundColor: 'var(--color-hovercard-bg)',
		borderRadius: '8px',
		padding: '16px',
		boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
		border: 0,
		width: '280px'
	},
	arrow: {
		backgroundColor: 'var(--color-hovercard-bg)',
		border: 0
	}
};
